import React from 'react';
import type { RichBlock } from '@/types/purchaseFlow';
import VendorListBlock from './VendorListBlock';
import ProductListBlock from './ProductListBlock';
import POSummaryBlock from './POSummaryBlock';
import InboundSummaryBlock from './InboundSummaryBlock';
import InvoiceSummaryBlock from './InvoiceSummaryBlock';
import MatchTableBlock from './MatchTableBlock';
import FlowChecklistBlock from './FlowChecklistBlock';
import CreateVendorFormBlock from './CreateVendorFormBlock';
import PartPickerBlock from './PartPickerBlock';
import PriceTierTableBlock from './PriceTierTableBlock';
import DeliveryDateBlock from './DeliveryDateBlock';
import DeliveryAddressBlock from './DeliveryAddressBlock';
import PaymentTermsBlock from './PaymentTermsBlock';

export interface ItemUpdate {
  part_code: string;
  quantity: number;
  unit_price: number;
}

export interface NewItem {
  part_code: string;
  product_name: string;
  specification: string;
  quantity: number;
  unit_price: number;
  currency: string;
}

interface RichBlockRendererProps {
  block: RichBlock;
  onAction: (message: string) => void;
  onUpdateItems?: (updates: ItemUpdate[], removals: string[]) => void;
  onUpdateFlowFields?: (fields: Record<string, unknown>) => void;
  onAddItem?: (item: NewItem) => void;
}

const RichBlockRenderer: React.FC<RichBlockRendererProps> = ({ block, onAction, onUpdateItems, onUpdateFlowFields, onAddItem }) => {
  switch (block.type) {
    case 'vendor_list':
      return <VendorListBlock data={block.data} onAction={onAction} />;
    case 'vendor_created':
      return <VendorListBlock data={block.data} onAction={onAction} created />;
    case 'product_list':
      return <ProductListBlock data={block.data} onAction={onAction} onAddItem={onAddItem} />;
    case 'product_created':
      return <ProductListBlock data={block.data} onAction={onAction} created />;
    case 'quotation_list':
      return <ProductListBlock data={block.data} onAction={onAction} isQuotation />;
    case 'price_tier_table':
      return <PriceTierTableBlock data={block.data} onUpdateItems={onUpdateItems} />;
    case 'delivery_date':
      return <DeliveryDateBlock onUpdateFields={onUpdateFlowFields} />;
    case 'delivery_address':
      return <DeliveryAddressBlock data={block.data} onUpdateFields={onUpdateFlowFields} />;
    case 'payment_terms':
      return <PaymentTermsBlock data={block.data} onUpdateFields={onUpdateFlowFields} />;
    case 'po_summary':
      return <POSummaryBlock data={block.data} />;
    case 'inbound_summary':
      return <InboundSummaryBlock data={block.data} />;
    case 'invoice_summary':
      return <InvoiceSummaryBlock data={block.data} />;
    case 'match_table':
      return <MatchTableBlock data={block.data} />;
    case 'flow_checklist':
      return <FlowChecklistBlock data={block.data} onAction={onAction} />;
    case 'create_vendor_form':
      return <CreateVendorFormBlock onAction={onAction} />;
    case 'part_picker':
      return <PartPickerBlock data={block.data} onAction={onAction} />;
    default:
      return null;
  }
};

export default RichBlockRenderer;
